import { formatChange, formatPrice } from "src/components/portfolio/helpers";
import { useUserSlice } from "src/store/features/user.slice";

interface AnalyticsTooltipProps {
  active?: boolean;
  payload?: Array<{
    value: number;
    name: string;
    dataKey: string;
  }>;
  label?: string;
  chartName?: string;
}

const AnalyticsTooltip = (props: AnalyticsTooltipProps) => {
  const { active, payload, label, chartName } = props;
  const {
    defaultCurrency: { code },
  } = useUserSlice();
  if (!active || !payload || !payload.length) {
    return null;
  }

  const styles = {
    container: {
      backgroundColor: "rgba(255, 255, 255, 0.98)",
      padding: "12px 16px",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.1)",
      border: "1px solid rgba(0, 0, 0, 0.05)",
      fontSize: "12px",
      minWidth: "140px",
    },
    header: {
      color: "#374151",
      fontWeight: "600",
      marginBottom: "8px",
      borderBottom: "1px solid #E5E7EB",
      paddingBottom: "4px",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "4px",
    },
    label: {
      color: "#6B7280",
      marginRight: "16px",
      display: "flex",
      alignItems: "center",
    },
    dot: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      marginRight: "6px",
    },
    value: {
      color: "#111827",
      fontWeight: "500",
    },
  };

  // Helper function to format values
  const formatValue = (value: any, dataKey: string) => {
    if (chartName === "customerAssetsHeld") {
      return formatChange(value);
    }
    if (chartName === "depositVolume") {
      return formatPrice(value, code);
    }

    if (dataKey === "fees") {
      return formatPrice(value, code);
    }

    return value;
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>{label}</div>
      {payload.map((entry: any, index: number) => (
        <div key={`item-${index}`} style={styles.row}>
          <div style={styles.label}>
            <div
              style={{
                ...styles.dot,
                backgroundColor: entry.color,
              }}
            />
            {entry.name}
          </div>
          <div style={styles.value}>{formatValue(entry.value, entry.dataKey)}</div>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsTooltip;
